import { set } from 'mongoose';
import React,  {useState, useEffect}  from 'react';
import {useParams, useRouteMatch, useLocation, Link, useHistory, Switch, Route} from 'react-router-dom'
import '../../styles.css'


function Headers(){

   const [headerMuseums, setHeaderMuseums] = useState(false);
   const [headerExhibitions, setHeaderExhibitions] = useState(false);
   const [headerEvents, setHeaderEvents] = useState(false);

   let urlInData = useLocation();
   let url =urlInData.pathname

   let tag = url.split('/')[1];

   useEffect(()=>{
    headerChange();
   },[tag])

   const headerChange = ()=>{
       if(tag=='museums'){
        museumsStateChange();
       } else if(tag=='exhibitions'){
        exhibitionStateChange();
       } else if(tag=='events'){
        eventsStateChange()
       }
   }

   const museumsStateChange =()=>{
       setHeaderMuseums(true);
       setHeaderExhibitions(false);
       setHeaderEvents(false)
   }

   const  exhibitionStateChange = ()=>{
         setHeaderMuseums(false);
         setHeaderExhibitions(true);
         setHeaderEvents(false);
   }

   const  eventsStateChange = ()=>{
         setHeaderMuseums(false);
         setHeaderExhibitions(false);
         setHeaderEvents(true);
   }

 return(
     <div className='header'>
         <div className='headerpart'> 
         <ul>
             <li><Link to='/museums/list/all' onClick={museumsStateChange} className={`link ${headerMuseums? "highlight" :""}`}>Museums</Link></li>
             <li><Link to='/exhibitions/current/list/all'  onClick={exhibitionStateChange} className={`link ${headerExhibitions? "highlight" :""}`}>Exhibitions</Link></li>
             <li><Link to='/events/current/list/all' onClick={eventsStateChange} className={`link ${headerEvents? "highlight" :""}`}>Events</Link></li>
         </ul>
         </div>
     </div>
 )
};

export default Headers;